import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {CircularProgress} from '@material-ui/core';

const blockUIRoot = document.querySelector('#block-ui-root');

export default class BlockUI extends React.Component {
  static propTypes = {
    shown: PropTypes.bool.isRequired,
  };
  static defaultProps = {
    shown: false,
  };

  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    if (this.props.shown) {
      blockUIRoot.appendChild(this.el);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {shown} = nextProps;
    if (shown !== this.props.shown) {
      if (shown) {
        blockUIRoot.appendChild(this.el);
      } else {
        blockUIRoot.removeChild(this.el);
      }
    }
  }

  componentWillUnmount() {
    if (blockUIRoot.contains(this.el)) {
      blockUIRoot.removeChild(this.el);
    }
  }

  render() {
    const {shown} = this.props;
    if (shown) {
      return ReactDOM.createPortal(
        <div>
          <CircularProgress thickness={7} />
        </div>,
        this.el,
      );
    }
    return null;
  }
}
